import { DefaultService } from '@/services/DefaultService';

export default class FiltroRelatorioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAllClienteVendas(limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/cliente/list.json?limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findClienteVendasById(id) {
        return this._http.get(`${this._env}/cliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCidade(page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/general/city.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findCidadeById(id) {
        return this._http.get(`${this._env}/general/city/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllEstado(page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/general/state.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findEstadoById(id) {
        return this._http.get(`${this._env}/general/state/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    //traz todos os usuarios da table usuarios;
    findAllVendedor(page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/employees.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findVendedorById(id) {
        return this._http.get(`${this._env}/promotor/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllRegiao(...param) {
        return this._http.get(encodeURI(`${this._env}/getcombo/regions.json?param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findRegiaoById(id) {
        return this._http.get(`${this._env}/regions/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllEmpresa(page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/empresaold.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findEmpresaById(id) {
        return this._http.get(`${this._env}/vendas/empresa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAtividade(page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/activity/atividades.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAtividadeById(id) {
        return this._http.get(`${this._env}/activity/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllGrupo(page, limit, situacao, idempresa = '0, ', ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/grupo.json?page=${page}&limit=${limit}&situacao=${situacao}&idempresa=${idempresa}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findGrupoById(id) {
        return this._http.get(`${this._env}/promotor/produto/grupo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findAllSubgrupo(page, limit, situacao, grupoid = 0, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/subgrupo.json?page=${page}&limit=${limit}&situacao=${situacao}&grupoid=${grupoid}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findSubgrupoById(id) {
        return this._http.get(`${this._env}/promotor/produto/subgrupo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllProduto(page, limit, ...param) {
        const filtros = {
            "idempresa": -1,
            "idtabpreco": [],
            "grupos": [],
            "subgrupos": [],
            "linhas": [],
            "fornecedores": [],
            "referencia": "",
            "complemento": "",
            "search": "",
            "bonificacao": 2,
            "promocao": 2,
            "kitCombo": 2,
            "situacao": 2,
            "catalogo": 2,
            "tabelaPreco": 2,
            "mostrarFotos": true
          }
        return this._http.post(encodeURI(`${this._env}/product.json?page=${page}&limit=${limit}&&param=${param}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllComboProduto(limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/sales/package/product/findallcomboproduto.json?limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findProdutoById(id) {
        return this._http.get(`${this._env}/product/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllPromotor(page = 0, limit = 50, situacao=2, ...params) {
        return this._http.get(encodeURI(`${this._env}/employees.json?page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findPromotorById(id) {
        return this._http.get(`${this._env}/promotor/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllContrato(page, limit) {
        return this._http.get(encodeURI(`${this._env}/promotor/contrato.json?page=${page}&limit=${limit}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findContratoById(id) {
        return this._http.get(`${this._env}/promotor/contrato/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllProProduto(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findProProdutoById(id) {
        return this._http.get(`${this._env}/promotor/produto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllRede(...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/getcombo/network.json?param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findRedeById(id) {
        return this._http.get(`${this._env}/promotor/rede/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findAllBandeira(...params) {
        return this._http.get(encodeURI(`${this._env}/promotor/getcombo/division.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findBandeiraById(id) {
        return this._http.get(`${this._env}/promotor/bandeira/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllLps(...params) {
        return this._http.get(encodeURI(`${this._env}/promotor/getcombo/lps.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findLpsById(id) {
        return this._http.get(`${this._env}/promotor/lps/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllTipoServico(...params) {
        return this._http.get(encodeURI(`${this._env}/promotor/getcombo/servicetype.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findTipoServicoById(id) {
        return this._http.get(`${this._env}/promotor/tipodeservico/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllLinhaProduto(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/linha.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findLinhaProdutoById(id) {
        return this._http.get(`${this._env}/promotor/produto/linha/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    findAllMotivosNaoVendas(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/sales/nosalesreason.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllMotivosNaoVendasFilter(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/sales/nosalesreason/filter.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findMotivoNaoVendaById(id) {
        return this._http.get(`${this._env}/sales/nosalesreason/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}